import { configReducer } from '../../store/config/config.reducer';
import { feedPageReducer } from '../../store/template/feedPage/feedPage.reducer';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
  GET_PALETTE_DATA,
  INJECT_ACCESSIBILITY_ICON_TO_HEADER,
  INJECT_ADS,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { headerReducer } from '../../store/navigations/navigation/header/header.reducer';
import { menuReducer } from '../../store/navigations/navigation/menu/menu.reducer';
import { footerReducer } from '../../store/navigations/navigation/footer/footer.reducer';
import { FeedPageLimaComponent } from './FeedPageLimaComponent';
import { getAnalyticsCoreParamsForAllPages } from '../utils/getAnalyticsCoreParams';
import { networkLinksReducer } from '../../store/navigations/navigation/networkLinks/networkLinks.reducer';

export const rootReducer = {
  config: configReducer,
  footer: footerReducer,
  header: headerReducer,
  menu: menuReducer,
  template: feedPageReducer,
  siteAnnouncement: announcementReducer,
  networkLinks: networkLinksReducer,
};

const getCoreParams = (state: AppState) => ({
  ...getAnalyticsCoreParamsForAllPages(state),
});

export const FeedPageLima = new TemplateRegistration()
  .setComponent(FeedPageLimaComponent)
  .setRootReducer(rootReducer)
  .setCoreParams(getCoreParams)
  .addClientAPIEvent(INJECT_VIDEO_LOGO)
  .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
  .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
  .addClientAPIEvent(GET_PALETTE_DATA)
  .addClientAPIEvent(INJECT_ACCESSIBILITY_ICON_TO_HEADER)
  .addClientAPIEvent(INJECT_ADS)
  .build();
